import colors from './colors'
import fonts from './fonts'

export const theme = {
  backgrounds: {
    overlay: 'rgba(0, 0, 0, 0.2)',
    overlayDark: 'rgba(0, 0, 0, 0.6)',
  },
  borderRadius: {
    default: '0.2rem',
    md: '0.35rem',
    lg: '0.5rem',
    pill: '50rem',
  },
  boxShadows: {
    card: {
      sm: '0 0.1rem 0.2rem rgba(0, 0, 0, 0.15), 0 1.5rem 1.5rem -1rem rgba(0, 0, 0, 0.21)',
      md: '0 0.2rem 0.4rem rgba(0, 0, 0, 0.17), 0 1.5rem 1.5rem -1rem rgba(0, 0, 0, 0.25)',
      lg: '0 0.2rem 0.4rem rgba(0, 0, 0, 0.19), 0 1.5rem 1.5rem -1rem rgba(0, 0, 0, 0.29)',
      hover:
        '0 0.1rem 0.2rem rgba(0, 0, 0, 0.19), 0 1.5rem 1.5rem -1rem rgba(0, 0, 0, 0.39)',
    },
    btn: {
      sm: '0 0.1rem 0.2rem rgba(0, 0, 0, 0.15), 0 0.2rem 0.2rem 0.2rem rgba(0, 0, 0, 0.21)',
      hover:
        '0 0.05rem 0.05rem rgba(0, 0, 0, 0.07), 0 0.05rem 0.1rem 0.05rem rgba(0, 0, 0, 0.09)',
    },
    large:
      '0 0.1rem 0.2rem rgba(0, 0, 0, 0.24), 0 0.2rem 0.2rem -1rem rgba(0, 0, 0, 0.345)',
    icon: 'rgba(0, 0, 0, 0.1) 0rem 0.1rem 0.3rem 0rem, rgba(0, 0, 0, 0.06) 0rem 0.1rem 0.2rem 0rem',
    overlay: ` 0px 2px 10px rgba(0, 0, 0, 0.25)`,
  },
  colors,
  fonts,
  header: {
    desktopHeight: '5rem',
  },
  maxWidths: {
    mobileS: '375px',
    mobileM: '425px',
    mobileL: '768px',
    tablet: '1024px',
    laptop: '1440px',
    laptopL: '2560px',
  },
  titleSizes: {
    h1: '2.1875rem',
    h2: '1.5625rem',
    h3: '1.25rem',
    h4: '2.8rem',
    h5: '2.4rem',
    h6: '2.0rem',
  },
  transitions: {
    default: 'all 0.2s ease',
    cubic: 'cubic-bezier(0.497, 0.51, 0.25, 1)',
    smooth: 'cubic-bezier(0.845, 0, 0.165, 1)',
  },
  btnSizes: {
    sm: '0.5rem 1rem',
    md: '0.75rem 1.25rem',
    lg: '1rem 1.5rem',
  },
  iconSizes: {
    sm: '1.5rem',
    md: '2rem',
    lg: '3rem',
  },
}

export default theme
